import { Partner } from './advisor.model';
export class AdvisorConst {
  public static headerTable = [
    { field: 'name', title: 'Nombre', cell: (row) => `${row.name}`, class: (row) => `` },
    { field: 'vatNumber', title: 'NIF', cell: (row) => row.vatNumber, class: (row) => `` },
    { field: 'province', title: 'Provincia', cell: (row) => row.province, class: (row) => `` },
    { field: 'municipality', title: 'Municipio', cell: (row) => row.municipality, class: (row) => `` },
    { field: 'clientsCount', title: 'Nº clientes', cell: (row) => row.clientsCount, class: (row) => `` },

  ];
}